export default "__VITE_ASSET__CC_Zz_89__"